import {
    ControlFactory,
    DetailViewContext,
} from 'radpresentation.htmlclient.defaultviewextensions';

export default class UIListenerUtility {
    public static hideControlViaOtherControl(
        context: DetailViewContext,
        controllingControl: string,
        controlToHide: string,
        conditionFn: (controllingValue: any) => boolean = (value) => value) {
            const controllingObs = context.genericObject.getObservable<any>(controllingControl);
            const controlToChange = context.getUIFactory<ControlFactory>(controlToHide);
            controllingObs.sync(controlToChange.isVisible, conditionFn);
    }

    public static disableControlViaOtherControl(
        context: DetailViewContext,
        controllingControl: string,
        controlToDisable: string,
        conditionFn: (controllingValue: any) => boolean = (value) => value) {
        const controllingObs = context.genericObject.getObservable<any>(controllingControl);
        const controlToChange = context.getUIFactory<ControlFactory>(controlToDisable);
        controllingObs.sync(controlToChange.isEnabled, conditionFn);
    }

    public static makeEverythingReadonly(context: DetailViewContext) {
        const controls = context.getCreatedControlFactories();
        for (const control of controls)
        {
            control.isEnabled(false);
        }
    }
}